import { OnlyYouIndicator } from 'components/OnlyYouIndicator';
import { ProfileImage } from 'components/ProfileImage';
import React, { CSSProperties } from 'react';
import styled from 'styled-components';
import { colors } from 'styleguide/colors';
import { Spacing } from 'styleguide/spacing';
import { H5, P3 } from 'styleguide/Texts';
import { View } from 'styleguide/View';

const Container = styled.div`
  display: flex;
  align-items: center;
`;

interface UserHeaderProps {
  username: string;
  date: string;
  isPrivateWorkout?: boolean;
  isCoached?: boolean;
  profileImage?: string;
  style?: CSSProperties;
}

export const UserHeader = ({
  username,
  date,
  isPrivateWorkout,
  isCoached,
  profileImage,
  style,
}: UserHeaderProps) => {
  return (
    <Container style={style}>
      <ProfileImage source={profileImage} diameter={55} />
      <View style={{ marginInlineStart: Spacing.md, gap: Spacing.xs }}>
        <H5>{username}</H5>
        <View style={{ flex: 1, flexDirection: 'row', alignItems: 'center', gap: Spacing.xs }}>
          <P3 style={{ color: colors.grey }}>{date}</P3>
          {isPrivateWorkout && <OnlyYouIndicator tint={colors.grey} isCoached={isCoached} />}
        </View>
      </View>
    </Container>
  );
};
